<template>
    <div class="home-main-all">
        <el-breadcrumb separator="/" class="home-main-breadcrumb">
            <template >
                <el-breadcrumb-item v-if="$store.state.sideInfo.menu" >
                    <span>{{$store.state.sideInfo.menu.title}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="$store.state.sideInfo.submenu">
                    <span >{{$store.state.sideInfo.submenu.title}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="$store.state.sideInfo.article">{{$store.state.sideInfo.article.title}}
                </el-breadcrumb-item>
            </template>
        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        name: "HomeMainTopBar",
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {

        },

    };
</script>

<style lang="less" scoped>
    .home-main-all {
        display: flex;
        flex-direction: column;
        align-items: left;
        /*background-color: red;*/
    }

    .home-main-breadcrumb {
        /*margin-top: 20px;*/
        font-size: 12px;
        /*background-color: red;*/
    }

    .home-main-top-bar {
        width: 100%;
        border-bottom: 1px solid #DDD;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        height: 25px;
        .span_ {
            min-width: 80px;
            border-left: 2px solid #88B7E0;
            font-weight: 600;
            line-height: 1.1;
            color: inherit;
            font-size: 16px;
            text-indent: 8px;
        }
    }

    .home-main-top-bar-t {
        width: 100%;
        padding-bottom: 5px;
    }

</style>